<!-- eslint-disable -->
<template>
  <div v-if="visible" class="crm-modal-backdrop" @click.self="$emit('close')">
    <div class="crm-modal shadow-lg">
      <div class="crm-modal__header">
        <div class="d-flex align-items-center">
          <feather-icon icon="SlidersIcon" size="18" class="mr-2 text-primary" />
          <h5 class="crm-modal__title m-0">Board Display Settings</h5>
        </div>
        <button type="button" class="crm-modal__close" @click="$emit('close')">
          <feather-icon icon="XIcon" size="20" />
        </button>
      </div>

      <div class="crm-modal__body scrollable-y">
        <!-- Density -->
        <div class="form-group mb-4">
          <label class="crm-label">Card Density</label>
          <div class="d-flex gap-2 mt-1">
            <label class="crm-radio-card flex-grow-1" :class="{ 'crm-radio-card--active': settings.density === 'comfortable' }">
              <input
                type="radio"
                name="density"
                value="comfortable"
                :checked="settings.density === 'comfortable'"
                @change="$emit('settings-change', { key: 'density', value: 'comfortable' })"
              />
              <span class="font-weight-bold">Comfortable</span>
              <span class="text-xs text-muted">Full details & padding</span>
            </label>
            <label class="crm-radio-card flex-grow-1" :class="{ 'crm-radio-card--active': settings.density === 'compact' }">
              <input
                type="radio"
                name="density"
                value="compact"
                :checked="settings.density === 'compact'"
                @change="$emit('settings-change', { key: 'density', value: 'compact' })"
              />
              <span class="font-weight-bold">Compact</span>
              <span class="text-xs text-muted">Dense view for high volume</span>
            </label>
          </div>
        </div>

        <!-- Card Fields Visibility Toggles -->
        <div class="form-group mb-4">
          <label class="crm-label">Visible Card Elements</label>
          <div class="d-flex flex-column gap-2 mt-1">
            <label class="d-flex align-items-center justify-content-between cursor-pointer">
              <span class="text-sm">Show Labels</span>
              <input
                type="checkbox"
                :checked="settings.showLabels"
                @change="$emit('settings-change', { key: 'showLabels', value: $event.target.checked })"
              />
            </label>
            <label class="d-flex align-items-center justify-content-between cursor-pointer">
              <span class="text-sm">Show Due Dates</span>
              <input
                type="checkbox"
                :checked="settings.showDueDates"
                @change="$emit('settings-change', { key: 'showDueDates', value: $event.target.checked })"
              />
            </label>
            <label class="d-flex align-items-center justify-content-between cursor-pointer">
              <span class="text-sm">Show Assignees</span>
              <input
                type="checkbox"
                :checked="settings.showAssignees"
                @change="$emit('settings-change', { key: 'showAssignees', value: $event.target.checked })"
              />
            </label>
            <label class="d-flex align-items-center justify-content-between cursor-pointer">
              <span class="text-sm">Show Values / Financials</span>
              <input
                type="checkbox"
                :checked="settings.showValues"
                @change="$emit('settings-change', { key: 'showValues', value: $event.target.checked })"
              />
            </label>
          </div>
        </div>

        <!-- Card Aging -->
        <div class="form-group mb-3">
          <div class="d-flex align-items-center justify-content-between mb-1">
            <label class="crm-label m-0">Card Aging Visual</label>
            <input
              type="checkbox"
              :checked="settings.cardAging"
              @change="$emit('settings-change', { key: 'cardAging', value: $event.target.checked })"
            />
          </div>
          <p class="text-xs text-muted">Highlight cards that have not moved stages for a long period.</p>
          <div v-if="settings.cardAging" class="d-flex align-items-center mt-2">
            <span class="text-xs text-muted mr-2">Highlight after:</span>
            <input
              type="number"
              class="form-control form-control-sm mr-1"
              style="width: 70px;"
              min="1"
              :value="settings.cardAgingDays"
              @change="$emit('settings-change', { key: 'cardAgingDays', value: Number($event.target.value) })"
            />
            <span class="text-xs text-muted">days in stage</span>
          </div>
        </div>
      </div>

      <div class="crm-modal__footer">
        <button type="button" class="btn btn-primary" @click="$emit('close')">Save & Close</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'BoardSettings',
  props: {
    visible: { type: Boolean, required: true },
    settings: { type: Object, required: true }
  }
}
</script>

<style lang="scss" scoped>
$primary: #6366f1;
$slate-100: #f1f5f9;
$slate-200: #e2e8f0;
$slate-500: #64748b;
$slate-900: #0f172a;

.crm-modal-backdrop {
  position: fixed; top: 0; left: 0;
  width: 100vw; height: 100vh;
  background-color: rgba($slate-900, 0.5);
  backdrop-filter: blur(3px);
  z-index: 1050;
  display: flex; align-items: center; justify-content: center;
}

.crm-modal {
  background-color: #ffffff; border-radius: 12px;
  width: 90%; max-width: 460px; max-height: 90vh;
  display: flex; flex-direction: column;

  &__header { padding: 1.25rem; border-bottom: 1px solid $slate-200; display: flex; justify-content: space-between; align-items: center; }
  &__title { margin: 0; font-weight: 800; }
  &__close { border: none; background: transparent; color: $slate-500; cursor: pointer; }
  &__body { padding: 1.25rem; overflow-y: auto; }
  &__footer { padding: 1rem 1.25rem; border-top: 1px solid $slate-200; display: flex; justify-content: flex-end; }
}

.crm-label { font-size: 0.72rem; font-weight: 800; color: $slate-500; text-transform: uppercase; }

.crm-radio-card {
  border: 1px solid $slate-200;
  background-color: $slate-100;
  border-radius: 8px;
  padding: 0.65rem;
  display: flex; flex-direction: column;
  cursor: pointer;
  transition: all 0.15s ease;

  input { display: none; }

  &--active {
    border-color: $primary;
    background-color: rgba($primary, 0.05);
  }
}

.gap-2 { gap: 0.65rem; }
.scrollable-y { overflow-y: auto; }
.cursor-pointer { cursor: pointer; }
</style>
